import { DependencyList, EffectCallback, useEffect } from "react";

import useIsFirstRender from "./useIsFirstRender";
//! this hook will skip the first render and sideeffects only ocur after init render
function useUpdateEffect(effect: EffectCallback, deps?: DependencyList) {
  const isFirst = useIsFirstRender();

  useEffect(() => {
    if (!isFirst) {
      return effect();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}

export default useUpdateEffect;
